"use client";

import { useResponsive } from "@/app/hooks/useResponsive";
import { motion } from "framer-motion";
import Image from "next/image";

export default function Header() {
  const { isLg } = useResponsive();
  return (
    <div className="text-center mb-16">
      <motion.h2
        className="
				text-3xl sm:text-4xl md:text-5xl lg:text-6xl
				font-bold 
				text-primary-foreground 
				mb-6 
				flex flex-col sm:flex-row items-center justify-center gap-y-2 sm:gap-x-2
  			"
        initial={{ opacity: 0, y: 40 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, amount: 0.2 }}
        transition={{ duration: 0.5 }}
      >
        <span>O que torna a</span>
        <Image
          className="lg:mt-2 md:mt-2 h-auto w-auto"
          src="/escapa/transp/escapa_2.png"
          alt="Logo da escapa"
          width={isLg ? 220 : 120}
          height={0}
          style={{ height: "auto" }}
        />
        <span>única?</span>
      </motion.h2>

      <motion.p
        className="text-xl text-primary-foreground/90 max-w-3xl mx-auto mb-6"
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, amount: 0.2 }}
        transition={{ duration: 0.5, delay: 0.1 }}
      >
        Nossas entregas vão além do esperado, combinando tecnologia,
        sensibilidade e visão global.
      </motion.p>

      <motion.span
        className="text-base text-gray-400 max-w-3xl mx-auto"
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, amount: 0.2 }}
        transition={{ duration: 0.5, delay: 0.1 }}
      >
        Transformamos o turismo e o entretenimento com mapeamento completo da
        jornada do cliente, treinamentos e assessoria para elevar seu negócio à
        excelência, e soluções de IA personalizadas que diferenciam sua empresa
        no mercado.
      </motion.span>
    </div>
  );
}
